// ── FILTRO DE CONTENIDO — SIT Platform ──────────────────────────────────────
//
// Resistente a las evasiones más comunes:
//   • Mayúsculas / minúsculas           → "PUTA", "Puta"
//   • Espacios entre letras             → "p u t a", "m m g", "v e r g a"
//   • Separadores entre letras          → "p.u.t.a", "p-u-t-a", "p*ta"
//   • Leet speak                        → "put@", "p0rno", "$exo", "v3rg4"
//   • Letras repetidas                  → "puuuuta", "mmmmg"
//   • Caracteres invisibles / control   → zero-width spaces, soft hyphens
//   • Acentos alterados                 → "putá", "vergá", "coñó"
//   • Palabras compuestas sin espacio   → "mamaguevo", "comepinga"

// ── Normalización ─────────────────────────────────────────────────────────────
function normalizeText(text) {
  let t = text.toLowerCase();

  // 1. Eliminar caracteres invisibles y de control
  //    (zero-width space, soft hyphen, BOM, etc.)
  // eslint-disable-next-line no-control-regex
  t = t.replace(/[ -­​-‍﻿]/g, " ");

  // 2. Normalizar Unicode y eliminar diacríticos (á→a, ó→o, ñ→n, ü→u, ç→c…)
  t = t.normalize("NFD").replace(/[̀-ͯ]/g, "");

  // 3. Sustituir leet speak y sustituciones comunes
  t = t
    .replace(/@/g,  "a").replace(/4/g,  "a")
    .replace(/3/g,  "e")
    .replace(/1/g,  "i").replace(/!/g,  "i").replace(/\|/g, "i")
    .replace(/0/g,  "o")
    .replace(/\$/g, "s").replace(/5/g,  "s")
    .replace(/7/g,  "t").replace(/\+/g, "t")
    .replace(/8/g,  "b")
    .replace(/9/g,  "g");

  // 4. Eliminar separadores entre letras: p.u.t.a → puta, p-u-t-a → puta
  t = t.replace(/(\w)[.\-*_/\\,;:'](\w)/g, "$1$2");

  // 5. Colapsar letras individuales separadas por espacios:
  //    "p u t a" → "puta", "m m g" → "mmg", "v e r g a" → "verga"
  //    Solo colapsa si TODOS los tokens son caracteres individuales.
  t = t.replace(/\b\w(?:\s+\w)+\b/g, (match) => {
    const parts = match.split(/\s+/);
    return parts.every((p) => p.length === 1) ? parts.join("") : match;
  });

  // 6. Colapsar letras repetidas (2+ del mismo carácter → 1):
  //    "puuuuta" → "puta", "mmg" ya es "mmg", "puuuta" → "puta"
  t = t.replace(/(.)\1+/g, "$1");

  return t;
}

// ── Lista de palabras y frases prohibidas ────────────────────────────────────
// Organizada por categoría. Las entradas CON espacios se evalúan como frases.
// Escríbelas siempre en minúsculas y sin acentos (la normalización las iguala).

const badWords = [

  // ── Insultos y ofensas generales ─────────────────────────────────────────
  "puta", "putas", "puto", "putos", "putaza", "putazo", "putear", "putearon",
  "puta madre", "hijo de puta", "hija de puta", "hijos de puta", "hijas de puta",
  "puta vida", "puta mierda",
  "zorra", "zorras",
  "bastardo", "bastarda", "bastardos", "bastardas",
  "malparido", "malparida", "malparidos", "malparidas",
  "cabron", "cabrona", "cabrones", "cabronas",
  "pendejo", "pendeja", "pendejos", "pendejas", "pendejada", "pendejadas",
  "maldito", "maldita", "malditos", "malditas", "maldicion",
  "estupido", "estupida", "estupidos", "estupidas",
  "imbecil", "imbeciles",
  "idiota", "idiotas",
  "retrasado", "retrasada", "retrasados", "retrasadas",
  "tarado", "tarada", "tarados", "taradas",
  "mongolico", "mongolica",

  // ── Órganos / léxico sexual explícito ────────────────────────────────────
  "pene", "penes",
  "pito", "pitos",
  "verga", "vergas", "vergudo", "verguda", "vergon", "vergona",
  "falo", "falos",
  "vagina", "vaginas",
  "concha", "conchas",
  "chocha", "chochas",
  "cono", "conos",           // normalizado de "coño"
  "teta", "tetas", "pezon", "pezones", "chichis",
  "culo", "culos", "culero", "culera", "culeros", "culeras",
  "nalgon", "nalgona", "nalgas",
  "ano", "anos",
  "trasero", "traseros",

  // ── Actos sexuales ───────────────────────────────────────────────────────
  "sexo", "sexual", "sexuales", "sexualidad", "sexualmente",
  "masturbar", "masturbarse", "masturbacion", "masturbaciones",
  "pajearse", "paja", "pajas",
  "eyacular", "eyaculacion", "eyaculaciones",
  "corrida", "corridas", "correrse",
  "orgasmo", "orgasmos", "orgasmico", "orgasmica",
  "penetrar", "penetracion", "penetraciones", "penetrada", "penetrado",
  "chupar", "chupada", "chupadas",
  "mamada", "mamadas",
  "lamida", "lamidas",
  "felacion", "felaciones",
  "cojer", "coger", "cogida", "cogidas", "cogido", "cogidos",
  "follar", "follada", "folladas", "follado", "follados",
  "joder", "jodido", "jodida", "jodidos", "jodidas",
  "chingar", "chingada", "chingado", "chingados", "chingadas", "chingadera", "chingaderas",
  "te lo meto", "te la meto", "me lo metes", "me la metes",
  "meterstelo",
  "culiao", "culiada", "culiados", "culiadas", "culiar", "culiando",

  // ── Pornografía ───────────────────────────────────────────────────────────
  "pornografia", "porn", "porno", "pornos", "pornografico", "pornografica",

  // ── Delitos sexuales / parafilias ────────────────────────────────────────
  "violacion", "violaciones", "violar", "violada", "violado", "violador", "violadores",
  "incesto", "incestuoso", "incestuosa",
  "zoofilia", "bestialismo",
  "pedofilia", "pedofilo", "pedofila", "pedofilos", "pedofilas",
  "necrofilia",
  "orgia", "orgias",
  "sadomasoquismo", "bdsm", "sadismo", "masoquismo",
  "prostitucion", "prostituta", "prostitutas", "prostituto", "prostitutos", "prostituir",

  // ── Violencia / crimen / terrorismo ──────────────────────────────────────
  "asesinato", "asesinatos", "asesinar", "asesinado", "asesinada", "asesino", "asesinos", "asesina", "asesinas",
  "terrorismo", "terrorista", "terroristas",
  "explosivo", "explosivos",
  "delincuente", "malhechor",

  // ── Drogas ───────────────────────────────────────────────────────────────
  "droga", "drogas", "drogadicto", "drogadictos", "drogadicta", "drogadictas", "drogado", "drogada",
  "cocaina", "crack",
  "heroina",
  "metanfetamina",
  "marihuana", "weed", "porro", "porros", "mota",

  // ── Mierda y derivados ────────────────────────────────────────────────────
  "mierda", "mierdas", "mierdero", "mierderos",
  "comemierda", "come mierda",
  "caga e mierda",
  "mierduo", "mierdua",

  // ── Autolesión / suicidio ────────────────────────────────────────────────
  "suicidio", "suicida", "suicidarse",
  "matate", "matete",
  "quitate la vida",
  "me quiero morir",
  "ojala me muera", "ojala te mueras",
  "deseo morir",
  "muerate", "morite",

  // ── Discriminación / odio ─────────────────────────────────────────────────
  "racista", "racistas", "discriminacion",
  "homofobia", "homofobico", "homofobica",
  "transfobia", "transfobico", "transfobica",
  "fascista", "fascistas",
  "cono de tu madre",
  "animal sexual",

  // ── DOMINICANAS ──────────────────────────────────────────────────────────

  // Mamaguevo y compuestos
  "mamaguevo", "mamagueva", "mamaguevos", "mamaguevon", "mamaguevona",
  "mañema", "mamanema",
  "mamapinga", "mamapingas",
  "mmg", "mmgv",
  "comebicho", "come bicho",
  "comepinga", "come pinga",
  "jalabolas", "jalabicho", "jalasangre",

  // Singa y variantes
  "singa", "singao", "singada", "singaste", "singaron", "singadera", "singaderas", "singando",
  "singaputa", "singapinga", "singamama", "singapapo",
  "singador", "singadora",
  "singa tu vida",

  // Rapa y variantes
  "rapate", "rapapapo", "rapamama",
  "rapa tu vida",

  // Mondá / pinga / bicho
  "monda", "mondas", "mondazo",
  "pinga", "pingas", "pingudo", "pinguda", "pingon", "pingona",
  "bicho",           // en contexto dominicano: pene

  // Toto / grajo
  "toto",
  "grajo", "grajiento", "grajienta", "grajoso", "grajosa",

  // Cuero (meretriz en RD)
  "cuero", "cuera", "vieja cuero", "mala cuero",

  // Slurs LGBTQ+ dominicanos
  "maricon", "maricona", "maricones",
  "pajaro", "pajara", "pajaros",
  "bugarron", "bugarrones",
  "mariposon",
  "marimacho", "marimacha",

  // Insultos locales
  "lebron", "lebrona", "lebrones",
  "hijoeputa", "hijoeperra", "hijodeldiablo", "hijolagranputa", "hijoetigre",
  "desgraciao", "desgraciaos",
  "tigueron", "tiguere", "tigueraje",
  "lambon", "lambona", "lambones", "lambonas",
  "buscon", "buscona",
  "jartabla",
  "jodienda",
  "pajuo", "pajua", "pajuos", "pajuas",
  "baboso", "babosa", "babosos", "babosas",
  "manganzon", "manganzona",
  "mojon", "mojona", "mojones",
  "fuacata",
  "condenao", "condenada", "condenaos",
  "culolai",
  "culi cagao",
  "conazo",          // normalizado de "coñazo"
  "mardito",
  "ladronazo", "ladronaza",
  "rastrero", "rastrera", "rastreros", "rastreras",
  "jablador", "jabladora", "jabladores", "jabladoras",
  "pariguayo", "pariguaya", "pariguayos", "pariguayas",
  "palomo",          // slur en RD
  "huevon", "huevona", "huevones",
  "carajo",
  "chopo", "chopa",
  "diache",
  "diantre",
  "desgracia",       // en contexto insultante ("eres una desgracia")
  "maldita sea",
  "diablo e su maldita madre",
  "toto e diablo",
  "toto sucio",
  "loco el diablo",
  "puta e diablo",
  "comehombre", "comemujer",

];

// ── Pre-normalización de la lista (una sola vez al cargar el módulo) ─────────
const _normList   = badWords.map((w) => normalizeText(w));
const _phrases    = _normList.filter((w) => w.includes(" "));
const _wordSet    = new Set(_normList.filter((w) => !w.includes(" ")));

// Para búsqueda de substrings: solo palabras compuestas largas (≥ 7 chars)
// Estas son suficientemente específicas como para no generar falsos positivos.
const _longWords  = [..._wordSet].filter((w) => w.length >= 7);

// ── Función exportada ─────────────────────────────────────────────────────────
export function containsBadWords(text) {
  if (!text || typeof text !== "string") return false;

  const norm = normalizeText(text);

  // 1. Coincidencia por token (palabra individual)
  const tokens = norm.split(/[\s\W]+/).filter(Boolean);
  if (tokens.some((t) => _wordSet.has(t))) return true;

  // 2. Coincidencia de frases (entradas con espacios en la lista)
  if (_phrases.some((phrase) => norm.includes(phrase))) return true;

  // 3. Substring para palabras compuestas largas
  //    Captura "mamaguevo" aunque esté pegado o con variaciones de espaciado
  const noSpace = norm.replace(/\s+/g, "");
  if (_longWords.some((w) => noSpace.includes(w))) return true;

  return false;
}
